var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRewardIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.3333 9.04766L6.66665 5.23813M10.9447 3.87337L15.7066 6.59432C15.9983 6.76093 16.2407 7.00171 16.4093 7.29224C16.5779 7.58276 16.6667 7.91271 16.6666 8.24861V12.7038C16.6667 13.0398 16.5779 13.3697 16.4093 13.6602C16.2407 13.9507 15.9983 14.1915 15.7066 14.3581L10.9447 17.0791C10.657 17.2434 10.3314 17.3299 9.99998 17.3299C9.6686 17.3299 9.34296 17.2434 9.05522 17.0791L4.29331 14.3581C4.00164 14.1915 3.75921 13.9507 3.59062 13.6602C3.42202 13.3697 3.33325 13.0398 3.33331 12.7038V8.24861C3.33325 7.91271 3.42202 7.58276 3.59062 7.29224C3.75921 7.00171 4.00164 6.76093 4.29331 6.59432L9.05522 3.87337C9.34296 3.70901 9.6686 3.62256 9.99998 3.62256C10.3314 3.62256 10.657 3.70901 10.9447 3.87337Z",
    stroke: "#169560",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.80951 7.61914L9.09713 10.4668C9.37462 10.6161 9.68484 10.6943 9.99999 10.6943C10.3151 10.6943 10.6254 10.6161 10.9028 10.4668L16.1905 7.61914M9.99999 10.9525V17.143",
    stroke: "#169560",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRewardIcon);
export default __webpack_public_path__ + "static/media/rewardIcon.3ff73f4cfb7740b1acf8b7f9cc48b147.svg";
export { ForwardRef as ReactComponent };